module.exports = __webpack_public_path__ + "img/banner02.06076151.jpg";